import React, { useState, useEffect } from 'react';

import "../../Styles/AuthStyle.css";
import {
  FormWrapper,
  FormInputRow,
  FormMessage,
  FormTitle,
  PageLink,
  Button,
  FormLabel,
  FormInput,
} from "../../components/StyledComp/StyledComp";
import AdminUserService from "../../services/adminUserServices";
import { Link, useNavigate } from "react-router-dom";
import SignInLogo from "./SignInLogo";
import LoaderComponent from "../../components/StyledComp/Loader";
import { useDispatch } from "react-redux";
import { isShowLoader } from "../../store/apiSlice";
import { assignCapabilities } from "../../store/userSlice";

interface IState {
  user: {
    email: string;
    password: string;
  };
}

const SignIn: React.FC = () => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState("");
  const [state, setState] = useState<IState>({
    user: {
      email: "",
      password: "",
    },
  });
  const [buildNumber, setBuildNumber] = useState('1.0.0');
  const dispatch = useDispatch();

  const messageVariants = {
    hidden: { y: 30, opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { delay: 0.2, duration: 0.4 } },
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // console.log("updateinput  ", state);
    // console.log("updateinput1  ", event.target.name);
    setState({
      user: {
        ...state.user,
        [event.target.name]: event.target.value,
      },
    });
  };

  useEffect(() => {
      setBuildNumber(process.env.REACT_APP_BUILD_NUMBER || '1.0.0');
  }, []);

  const signIn = async (event: React.FormEvent<HTMLFormElement>) => {
    dispatch(isShowLoader(true));
    event.preventDefault();
    // console.log("email", state.user.email);
    // console.log("password", state.user.password);
    // setEmail("");
    // setPassword("");
    // setError(null);
    // setSuccess("Application was submitted!");
    const response = await AdminUserService.userLogin(
      state.user.email,
      state.user.password
    );
    console.log("response", response);
    if (response.data.data != null) {
      sessionStorage.setItem(
        "DsbaAdminToken",
        response.data.data[0][0].SessionToken
      );
      console.log("signinResponse:", response.data.data[0][0].LastName);
      sessionStorage.setItem("FirstName", response.data.data[0][0].FirstName);
      sessionStorage.setItem("LastName", response.data.data[0][0].LastName);
      // await new Promise(resolve => setTimeout(resolve, 5000)); //giving this time to set local storage
      const search = window.location.search;
      const params = new URLSearchParams(search);
      const redirectPath = params.get("path");
      dispatch(isShowLoader(false));
      dispatch(assignCapabilities(response.data.data[1]));
      navigate("/member/findmember", { replace: false });
    } else {
      console.log("**error***");
      console.log(response.data.errors);
      setError(response.data.errors);
      // setErrorMessage(response.data.error.errors);
    }
  };

  const formData = [
    {
      label: "Email",
      name: "email",
      value: state.user.email,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
        updateInput(event),
      type: "email",
      autoComplete: "email",
    },
    {
      label: "Password",
      name: "password",
      value: state.user.password,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
        updateInput(event),
      type: "password",
      autoComplete: "current-password",
    },
  ];

  return (
    <div className="signin-wrapper">
      <LoaderComponent />
      <div className="signin col-12 col-lg-8">
        <div className="signin-logo col-12 col-lg-5">
          <SignInLogo />
        </div>
        <div className="signin-form col-12 col-lg-7">
          <FormTitle>Sign In</FormTitle>
          <FormWrapper onSubmit={(e) => signIn(e)}>
            {formData.map((el, index) => (
              <FormInputRow key={index}>
                <FormLabel>{el.label}</FormLabel>
                <FormInput
                  type={el.type}
                  name={el.name}
                  placeholder={`Enter your ${el.label.toLocaleLowerCase()}`}
                  value={el.value}
                  autoComplete={el.autoComplete}
                  required
                  // onChange={(event: React.ChangeEvent<HTMLInputElement>) => updateInput(event)}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => updateInput(event)}
                />
              </FormInputRow>
            ))}
            <div className="loginbutton">
              <Button type="submit">Login</Button>
            </div>

            <Link to="/forgot-password" className="page-link">
              <PageLink>Forgot Password</PageLink>
            </Link>
          </FormWrapper>

          {error && (
            <FormMessage
              className="ErrorDiv"
              variants={messageVariants}
              initial="hidden"
              animate="animate"
            >
              {error}
            </FormMessage>
          )}
          {/* {success && (
                <FormMessage
                  variants={messageVariants}
                  initial="hidden"
                  animate="animate"
                  error={false}
                >
                  {success}
                </FormMessage> 
              )}  */}
        </div>
      </div>
      <div style={{ position: 'fixed', bottom: 0, right: 0, padding: '40px', backgroundColor: 'white' }}>
        Build Number: {buildNumber}
      </div>
    </div>
  );
};

export default SignIn;
